import { Alert, Card, Col, ConfigProvider, DatePicker, Divider, Form, List, Row, Select, Typography, Checkbox } from "antd";
import SDIModal from "../../../../components/ui/SDIModal";
import PropTypes from "prop-types";
import frFR from "antd/locale/fr_FR";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../../../../variables/api/axiosInstance";
import BarreBottom from "../../../../components/docs/BarreBottom";
import dayjs from "dayjs";
import AvenantAgencySelector from "./AvenantAgencySelector";

const { Text, Title } = Typography;

const DiminutionDeGarantie = (props) => {
    const [modalDiminutionGarantie, setModalDiminutionGarantie] = useState(
        props.open
    );

    const [loading, setLoading] = useState(false);
    const [garanties, setGaranties] = useState([[]]);
    const [garantiesActuelles, setGarantiesActuelles] = useState([]);
    const [currentPreview, setCurrentPreview] = useState("");
    const [preview, setPreview] = useState("");
    const [dateEffetAvenant, setDateEffetAvenant] = useState(() =>
        props?.contrat?.dateEffet ? dayjs(props?.contrat?.dateEffet) : dayjs()
    );

    useEffect(() => {
        if (props?.contrat?.codeId) {
            axiosInstance
                .get(
                    `/api/contrat/preview/${props?.contrat?.codeId}`
                )
                .then((response) => {
                    // console.log("DG Preview: ", response.data);
                    setCurrentPreview(response.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [props?.contrat?.codeId]);

    const { MinusCircleOutlined, SafetyCertificateOutlined, ExclamationCircleOutlined } = require('@ant-design/icons');

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XAF' }).format(value);
    };

    useEffect(() => {
        setModalDiminutionGarantie(props.open);
        if (props.open) {
            setDateEffetAvenant(props?.contrat?.dateEffet ? dayjs(props?.contrat?.dateEffet) : dayjs());
            // Récupérer les garanties actuelles du contrat qui peuvent être supprimées
            axiosInstance
                .get(
                    `/api/garantie/deletable/engins/${props?.contrat?.codeId}`)
                .then((response) => {
                    console.log(response.data);
                    setGarantiesActuelles(response.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }, [props.open, props?.contrat?.dateEffet]);

    const navigate = useNavigate();

    const handleSupprimerGarantie = (index, value) => {
        var gtys = [];
        if (value.length === 1) {
            gtys.push(JSON.parse(value));
        } else {
            value.forEach((element) => {
                try {
                    gtys.push(JSON.parse(element));
                } catch (err) {
                    gtys.push(element);
                }
            });
        }
        let garantiesActuellesCopy = [...garantiesActuelles];
        garantiesActuellesCopy?.forEach((e, i) => {
            if (i === index) {
                e.guaranty = gtys;
            }
        });
        // console.log("STY: ", gtys);
        console.log("gac: ", garantiesActuellesCopy);

        setGarantiesActuelles(garantiesActuellesCopy);
        triggerPreview(garantiesActuellesCopy, dateEffetAvenant);
    };

    const triggerPreview = (payloadSource, selectedDate) => {
        const formattedDate = selectedDate ? selectedDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;
        const payload = Array.isArray(payloadSource)
            ? payloadSource.map((engin) => ({
                ...engin,
                dateEffetAvenant: formattedDate,
            }))
            : [];

        axiosInstance
            .put(
                `/api/engin/preview-diminution-garantie/${props?.contrat?.codeId}${formattedDate ? `?dateEffet=${formattedDate}` : ""}`,
                payload
            )
            .then((ress) => {
                console.log("PREVIEW: ", ress.data);
                setPreview(ress.data);
            })
            .catch((errr) => {
                console.log(errr);
            });
    };

    const handleDateEffetChange = (date) => {
        setDateEffetAvenant(date);
        if (garantiesActuelles?.length) {
            triggerPreview(garantiesActuelles, date);
        }
    };

    const handleGarantiesChange = (index, e) => {
        let newGaranties = [...garanties];
        newGaranties[index] = e;
        setGaranties(newGaranties);
        handleSupprimerGarantie(index, e);
    };

    const enterLoading = () => {
        setLoading(true);
    };

    const outLoading = () => {
        setLoading(false);
    };

    const handleDiminutionSubmit = () => {
        enterLoading();
        console.log("All: ", preview);
        if (preview?.engins?.length > 0) {
            const formattedDate = dateEffetAvenant ? dateEffetAvenant.startOf('day').format('YYYY-MM-DDTHH:mm:ss') : null;
            const payload = {
                ...preview,
                dateEffetAvenant: formattedDate,
                ...(formattedDate ? { dateEffet: formattedDate } : {})
            };
            axiosInstance
                .put(
                    `/api/engin/diminution-garantie`,
                    JSON.stringify(payload))
                .then((resEngin) => {
                    toast("Diminution de garanties effectuée!");
                    outLoading();
                    setModalDiminutionGarantie(false);
                    props.update(false);
                    navigate(`/details-contrat/${resEngin.data.codeId}`, { replace: true });
                    window.location.reload();
                })
                .catch((errEngin) => {
                    console.log(errEngin);
                    toast("Erreur lors de la diminution des garanties");
                    outLoading();
                });

        } else {
            toast("Aucune garantie supprimée");
            outLoading();
            setModalDiminutionGarantie(false);
            props.update(false);
        }
    };

    const handleCancel = () => {
        setModalDiminutionGarantie(false);
        props.update(false);
    };

    // Fonction pour vérifier si une garantie peut être supprimée
    const isGarantieSupprimable = (garantie) => {
        return !garantie.obligatoire || garantie.suppressible;
    };

    return (
        <SDIModal
            title="DIMINUTION DE GARANTIES"
            centered
            confirmLoading={loading}
            open={modalDiminutionGarantie}
            onOk={() => handleDiminutionSubmit()}
            onCancel={() => handleCancel()}
            width={900}
            zIndex={1940}
        >
            <ConfigProvider locale={frFR}>
                <div className="diminution-garanties-content">
                    <AvenantAgencySelector
                        organismeCode={props?.contrat?.organisme?.code}
                        defaultAgence={props?.contrat?.producteur?.agence || props?.contrat?.intermediaire?.agence}
                    />
                    {/* Avertissement */}
                    <Alert
                        message="Attention"
                        description="La suppression de garanties réduit la couverture de ce contrat. Assurez-vous de bien comprendre les implications avant de valider."
                        type="warning"
                        icon={<ExclamationCircleOutlined />}
                        showIcon
                        className="mb-4"
                    />

                    <Card className="mb-3" size="small" title="Paramètres de l'avenant">
                        <Form layout="vertical">
                            <Form.Item label="Date d'effet de l'avenant" required>
                                <DatePicker
                                    value={dateEffetAvenant}
                                    onChange={handleDateEffetChange}
                                    format="DD/MM/YYYY"
                                    allowClear={false}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Form>
                    </Card>

                    {currentPreview?.engins ? currentPreview?.engins?.map((item, index) => (
                        <div key={item.codeId} className="engin-section">
                            {/* Section Récapitulatif de l'engin */}
                            <Card className="mb-4" size="small" style={{ backgroundColor: "#14356a" }} >
                                <div className="engin-recap">
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <div className="info-item" >
                                                <Text style={{ color: "white" }} strong>Immatriculation:</Text>
                                                <Text style={{ color: "white" }} className="ml-2">{item.immatriculation}</Text>
                                            </div>
                                            <div className="info-item">
                                                <Text style={{ color: "white" }} strong>Marque:</Text>
                                                <Text style={{ color: "white" }} className="ml-2">{item.marque}</Text>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="info-item">
                                                <Text style={{ color: "white" }} strong>N° Chassis:</Text>
                                                <Text style={{ color: "white" }} className="ml-2">{item.numeroChassis}</Text>
                                            </div>
                                            <div className="info-item">
                                                <Text style={{ color: "white" }} strong>Type:</Text>
                                                <Text style={{ color: "white" }} className="ml-2">{item.type || 'N/A'}</Text>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>

                            {/* Section Garanties actuelles */}
                            <Card className="mb-4" size="small" title="Garanties actuellement souscrites">
                                <Row gutter={16}>
                                    {/* Garanties obligatoires */}
                                    <Col span={12}>
                                        <div className="garanties-section">
                                            <Title level={5} className="section-title">
                                                <SafetyCertificateOutlined className="mr-2" />
                                                Garanties Obligatoires
                                            </Title>
                                            <List
                                                size="small"
                                                dataSource={item?.compulsoryGuaranties?.filter((garantie) => garantie.obligatoire && garantie.primeNette) || []}
                                                renderItem={(garantie) => (
                                                    <List.Item>
                                                        <div className="garantie-item">
                                                            <SafetyCertificateOutlined className="text-red-500 mr-2" />
                                                            <div>
                                                                <Text strong>{garantie.nom}</Text>
                                                                <div className="garantie-details">
                                                                    <Text type="secondary">
                                                                        Capital: {formatCurrency(garantie.capital)}
                                                                    </Text>
                                                                    <Text type="secondary" className="ml-3">
                                                                        Prime: {formatCurrency(garantie.primeNette)}
                                                                    </Text>
                                                                </div>
                                                                {!isGarantieSupprimable(garantie) && (
                                                                    <Text type="danger" className="garantie-non-supprimable">
                                                                        (Non supprimable)
                                                                    </Text>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                )}
                                            />
                                        </div>
                                    </Col>

                                    {/* Garanties optionnelles */}
                                    <Col span={12}>
                                        <div className="garanties-section">
                                            <Title level={5} className="section-title">
                                                <MinusCircleOutlined className="mr-2" />
                                                Garanties Optionnelles
                                            </Title>
                                            <List
                                                size="small"
                                                dataSource={item?.compulsoryGuaranties?.filter((garantie) => !garantie.obligatoire) || []}
                                                renderItem={(garantie) => (
                                                    <List.Item>
                                                        <div className="garantie-item">
                                                            <MinusCircleOutlined className="text-orange-500 mr-2" />
                                                            <div>
                                                                <Text strong>{garantie.nom}</Text>
                                                                <div className="garantie-details">
                                                                    <Text type="secondary">
                                                                        Capital: {formatCurrency(garantie.capital)}
                                                                    </Text>
                                                                    <Text type="secondary" className="ml-3">
                                                                        Prime: {formatCurrency(garantie.primeNette)}
                                                                    </Text>
                                                                </div>
                                                                <Text type="success" className="garantie-supprimable">
                                                                    (Supprimable)
                                                                </Text>
                                                            </div>
                                                        </div>
                                                    </List.Item>
                                                )}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </Card>

                            {/* Section Suppression de garanties */}
                            <Card className="mb-4" size="small" title="Supprimer des garanties">
                                {garantiesActuelles?.filter(e => e.codeId === item.codeId).length &&
                                    garantiesActuelles?.find(e => e.codeId === item.codeId)?.compulsoryGuaranties?.length ? (
                                    <div>
                                        <Form layout="vertical">
                                            <Form.Item label="Sélectionner les garanties à supprimer">
                                                <Select
                                                    mode="multiple"
                                                    placeholder="Choisir les garanties à supprimer..."
                                                    onChange={(event) => {
                                                        handleGarantiesChange(index, event);
                                                        handleSupprimerGarantie(index, event);
                                                    }}
                                                    options={garantiesActuelles?.find(e => e.codeId === item.codeId)?.compulsoryGuaranties
                                                        ?.filter(garantie => isGarantieSupprimable(garantie))
                                                        ?.map((guaranty, idx) => ({
                                                            label: (
                                                                <div className="garantie-option">
                                                                    <div className="garantie-name">{guaranty.nom}</div>
                                                                    <div className="garantie-price">
                                                                        <Text type="secondary">
                                                                            Prime Annuelle: {formatCurrency(-guaranty.primeNette)} |
                                                                            Capital: {formatCurrency(guaranty.capital)}
                                                                        </Text>
                                                                        <Text type="danger" className="ml-2">
                                                                            (Ristourne: {formatCurrency(guaranty.primeNette)})
                                                                        </Text>
                                                                    </div>
                                                                </div>
                                                            ),
                                                            value: JSON.stringify(guaranty),
                                                            key: idx
                                                        }))}
                                                    style={{ width: "100%" }}
                                                />
                                            </Form.Item>
                                        </Form>

                                        {/* Confirmation de suppression */}
                                        {garanties[index]?.length > 0 && (
                                            <Alert
                                                message="Confirmation requise"
                                                description="Vous êtes sur le point de supprimer des garanties. Cette action réduira votre couverture d'assurance."
                                                type="info"
                                                showIcon
                                                className="mt-3"
                                            />
                                        )}
                                    </div>
                                ) : (
                                    <Alert
                                        message="Aucune garantie supprimable"
                                        description="Toutes les garanties de cet engin sont obligatoires ou ne peuvent pas être supprimées"
                                        type="info"
                                        showIcon
                                    />
                                )}
                            </Card>

                            {/* Séparateur entre engins si plusieurs */}
                            {index < garantiesActuelles.length - 1 && <BarreBottom />}
                        </div>
                    )) : (
                        <Alert message="Aucune garantie supplémentaire disponible pour suppression" description="Toutes les garanties de cet engin sont obligatoires" type="info" showIcon />
                    )}

                    {/* Récapitulatif des économies */}
                    {garanties?.some(arr => arr?.length > 0) && (
                        <Card className="cost-summary mt-3" size="small">
                            <Title level={5}>Récapitulatif des ristournes</Title>
                            <div className="cost-breakdown">
                                <Row justify="space-between" className="cost-line">
                                    <Col>
                                        <Text>Date d'effet de l'avenant :</Text>
                                    </Col>
                                    <Col>
                                        <Text strong>{dateEffetAvenant ? dateEffetAvenant.format('DD/MM/YYYY') : '-'}</Text>
                                    </Col>
                                </Row>

                                <Divider className="my-2" />

                                <Row justify="space-between" className="cost-line">
                                    <Col>
                                        <Text>Ristourne prime nette au prorata:</Text>
                                    </Col>
                                    <Col>
                                        <Text strong className="text-green-600">
                                            {formatCurrency(preview?.primeNette) || 0}
                                        </Text>
                                    </Col>
                                </Row>

                                <Row justify="space-between" className="cost-line">
                                    <Col>
                                        <Text>Accessoires:</Text>
                                    </Col>
                                    <Col>
                                        <Text className="text-orange-500">
                                            {formatCurrency(preview?.accessoires) || 0}
                                        </Text>
                                    </Col>
                                </Row>

                                <Row justify="space-between" className="cost-line">
                                    <Col>
                                        <Text>Ristourne taxes(6%) :</Text>
                                    </Col>
                                    <Col>
                                        <Text className="text-green-600">
                                            {formatCurrency(preview?.taxes) || 0}
                                        </Text>
                                    </Col>
                                </Row>

                                <Divider className="my-2" />

                                <Row justify="space-between" className="cost-line total-cost">
                                    <Col>
                                        <Text strong className="text-lg">RISTOURNE TOTALE:</Text>
                                    </Col>
                                    <Col>
                                        <Text strong className="text-lg text-green-600">
                                            {formatCurrency(preview?.primeTotale) || 0}
                                        </Text>
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    )}
                </div>
            </ConfigProvider>

            <style jsx>
                {`
                    .diminution-garanties-content {
                        max-height: 70vh;
                        overflow-y: auto;
                    }
                    
                    .engin-section {
                        margin-bottom: 20px;
                    }
                    
                    .engin-recap .info-item {
                        margin-bottom: 8px;
                    }
                    
                    .garanties-section {
                        height: 100%;
                    }
                    
                    .section-title {
                        margin-bottom: 16px !important;
                        color: #1890ff;
                    }
                    
                    .garantie-item {
                        display: flex;
                        align-items: flex-start;
                        width: 100%;
                    }
                    
                    .garantie-details {
                        font-size: 12px;
                        margin-top: 4px;
                    }
                    
                    .garantie-non-supprimable {
                        font-size: 11px;
                        margin-top: 2px;
                        display: block;
                    }
                    
                    .garantie-supprimable {
                        font-size: 11px;
                        margin-top: 2px;
                        display: block;
                    }
                    
                    .garantie-option {
                        padding: 4px 0;
                    }
        
                    .garantie-name {
                        font-weight: 500;
                    }
                    
                    .garantie-price {
                        font-size: 12px;
                        margin-top: 2px;
                    }
                    
                    .cost-summary {
                        background-color: #f6ffed;
                        border: 1px solid #b7eb8f;
                    }
                    
                    .cost-breakdown .cost-line {
                        margin-bottom: 8px;
                    }
                    
                    .cost-breakdown .total-cost {
                        background-color: #e6fffb;
                        padding: 8px;
                        border-radius: 4px;
                        margin-top: 8px;
                    }
                    
                    .ml-2 { margin-left: 8px; }
                    .ml-3 { margin-left: 12px; }
                    .mr-2 { margin-right: 8px; }
                    .mt-3 { margin-top: 12px; }
                    .mb-4 { margin-bottom: 16px; }
                    .my-2 { margin: 8px 0; }
                    .text-lg { font-size: 16px; }
                    .text-green-600 { color: #52c41a; }
                    .text-red-500 { color: #ff4d4f; }
                    .text-orange-500 { color: #fa8c16; }
                `}
            </style>
        </SDIModal>
    );
};

DiminutionDeGarantie.propTypes = {
    open: PropTypes.bool,
    update: PropTypes.func,
    contrat: PropTypes.object
};

export default DiminutionDeGarantie;
